
import { TimerType, TimerSettings } from './timerTypes';

export const createStartAction = () => ({ type: 'START' as const });

export const createStopAction = () => ({ type: 'STOP' as const });

export const createResetAction = (timerType: TimerType, startRunning?: boolean, sequencePos?: number) => ({
  type: 'RESET_TIMER' as const,
  payload: { timerType, startRunning, sequencePos }
});

export const createTickAction = () => ({ type: 'TICK' as const });

export const createCompleteAction = (completedPomodoros: number) => ({
  type: 'SET_COMPLETED_POMODOROS' as const,
  payload: completedPomodoros
});

export const createUpdateSettingsAction = (settings: TimerSettings) => ({
  type: 'UPDATE_SETTINGS' as const,
  payload: settings
});

export const createChangeTypeAction = (timerType: TimerType) => ({
  type: 'CHANGE_TYPE' as const,
  payload: timerType
});

// Add the missing action creators that useTimerController expects
export const setFirstStart = (isFirstStart: boolean) => ({
  type: 'SET_FIRST_START' as const,
  payload: isFirstStart
});

export const setRunning = (isRunning: boolean) => ({
  type: 'SET_RUNNING' as const,
  payload: isRunning
});

export const setSessionIndex = (index: number) => ({
  type: 'SET_SESSION_INDEX' as const,
  payload: index
});

// Add the resetTimer function that useTimerState expects
export const resetTimer = (timerType: TimerType, settings: TimerSettings, startRunning?: boolean, sequencePos?: number) => ({
  type: 'RESET_TIMER' as const,
  payload: { timerType, startRunning, sequencePos }
});
